import { createContext } from 'use-context-selector';
import { ConsolidatedTransactionsProviderState } from './types';
import { defaultConsolidatedTransactionsProviderState } from './defaultState';

const ConsolidatedTransactionsContext = createContext<ConsolidatedTransactionsProviderState>(
  defaultConsolidatedTransactionsProviderState,
);

export { ConsolidatedTransactionsContext };
